import { ref } from "vue";

import { PageState } from "primevue/paginator";

export function usePaginatedDataTable() {
  const rowsPerPageOptions = [20, 30];
  const pageSize = ref(rowsPerPageOptions[0]);
  const page = ref(0);
  const totalRows = ref();

  function handlePageChange(pageState: PageState, callback: () => void) {
    pageSize.value = pageState.rows;
    page.value = pageState.page;
    callback();
  }

  return {
    rowsPerPageOptions,
    page,
    pageSize,
    totalRows,
    handlePageChange,
  };
}
